import React from 'react';
import PropTypes from 'prop-types';

class ListAds extends React.Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    rootClassName: PropTypes.string,
  };

  static defaultProps = {
    rootClassName: null,
  };

  render() {
    const { index, rootClassName } = this.props;

    return (
      <div className={rootClassName || undefined}>
        {(index === 7 || index === 17) &&
          <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-format="fluid"
            data-ad-layout-key="-et+5k+6r-el+2s"
            data-ad-client="ca-pub-8183181871645898"
            data-ad-slot="3991950634"
          />}
      </div>
    );
  }
}

export default ListAds;



// WEBPACK FOOTER //
// ./src/shared/components/ListAds/ListAds.js